import { InputText } from "primereact/inputtext";
import localeText from "../../../../locale";
import { Button } from "primereact/button";
import { useEffect, useRef, useState } from "react";
import IntegrationService from "../../../../service/IntegrationService";
import { Toast } from "primereact/toast";

const GtmConfig = () => {
  const integrationsService = new IntegrationService();

  const [gtmToken, setGtmToken] = useState("");
  const [loading, setLoading] = useState(false);

  const gtmCode = useRef(null);
  const toast = useRef(null);

  const gtmTokenInput = useRef("");

  const extraconomyToken = localStorage.getItem("__extraconomy_token");

  const configGtm = async (gtm) => {
    if (gtm === "" || !gtm) {
      toast.current.show({
        severity: "error",
        summary: localeText("fillInAllFields"),
      });

      return;
    }
    try {
      let res = await integrationsService.configGtm(gtm, extraconomyToken);
      toast.current.show({
        severity: "success",
        summary: localeText("gtmCodeSaved"),
        detail: localeText("pixelConfigSavedDetail"),
        life: 6000,
      });
      gtmCode.current = { result: { gtmcode: gtm } };
      return res;
    } catch (err) {
      toast.current.show({
        severity: "error",
        summary: localeText("pixelConfigError"),
        detail: localeText("pixelConfigErrorDetail"),
        life: 6000,
      });
      console.log(err);
    }
  };
  useEffect(() => {
    let mounted = true;
    setLoading(true);
    const integration = new IntegrationService();
    async function getGtm() {
      let res = await integration.getGtm(extraconomyToken);
      gtmCode.current = res;
    }
    getGtm().then(() => {
      setLoading(false);
      if (mounted && gtmCode.current?.result?.gtmcode) {
        setGtmToken(gtmCode.current.result.gtmcode);
      }
    });
    return () => {
      mounted = false;
    };
  }, [extraconomyToken]);

  return (
    <>
      <Toast ref={toast} />
      <div className="border-round" style={{ backgroundColor: "#46a748" }}>
        <h1 className="py-6 text-center text-0 lg:text-6xl md:text-6xl text-4xl">
          {localeText("googleTagManagerConfiguration")}
        </h1>
      </div>
      <div className="card border-300">
        {!loading ? (
          <h3>
            {gtmCode.current?.result?.gtmcode ? localeText("gtmEdit") : localeText("gtmRegister")}
          </h3>
        ) : null}

        <div className="flex flex-column gap-4">
          <div className="flex flex-column">
            <label htmlFor="access">{localeText("gtmCode")}</label>
            <InputText
              ref={gtmTokenInput}
              name="access"
              value={gtmToken}
              onChange={(e) => setGtmToken(e.target.value)}
              onBlur={() => {
                if (gtmToken === "" || !gtmToken) {
                  gtmTokenInput.current.style.border = "1px solid red";
                }
              }}
              onFocus={() => {
                gtmTokenInput.current.style.border = "1px solid #ced4da";
              }}
            />
          </div>
          <div>
            <Button onClick={() => configGtm(gtmToken)} label={localeText("savePixelConfig")} />
          </div>
        </div>
      </div>
    </>
  );
};

export default GtmConfig;
